import { render } from "./BranchMultiselect.vue?vue&type=template&id=351ba385"
import script from "./BranchMultiselect.vue?vue&type=script&lang=js"
export * from "./BranchMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__